import { useEffect, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "hooks/useContext";
import useAgencyState from "./useAgencyState";
import { STATUS_ACTIVE, SUBSTATUS_READY_FOR_WORK } from "utils/constantValues";

const useAgencyTeam = ({}) => {
  const navigate = useNavigate();
  const [loadPage, setLoadPage] = useState(false);
  const {
    user,
    getUserDetails,
    getUserDomains,
    getUserSubDomains,
    userDetails,
    userDomains,
    userSubDomains,
  } = useAppContext();

  const userId = user?.id;
  const agencyId = userDetails?.agencyId;

  const isRedirect =
    userDetails?.status &&
    (STATUS_ACTIVE !== userDetails?.status ||
      SUBSTATUS_READY_FOR_WORK !== userDetails?.subStatus);

  const {
    defaultPagination,
    initLoading,
    pagination,
    setPagination,
    totalCount,
    listAgencyTeam,
    users,
    resetOnUnmount,
    setUsers,
  } = useAgencyState({});

  const fetchUserDetails = useCallback(async () => {
    setLoadPage(true);
    try {
      await getUserDetails(userId);
      await getUserDomains(userId);
      await getUserSubDomains(userId);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadPage(false);
    }
  }, [userId]);

  useEffect(() => {
    if (agencyId) {
      listAgencyTeam(pagination);
    }
  }, [agencyId, pagination]);

  useEffect(() => {
    if (userId) {
      listAgencyTeam(pagination);
    }
    if (userId && isRedirect) {
      navigate("/");
    }
  }, [userId]);

  useEffect(() => {
    fetchUserDetails();

    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    totalCount,
    users,
    initLoading,
    pagination,
    setPagination,
    defaultPagination,
    setUsers,
    userDetails,
    userDomains,
    userSubDomains,
    loadPage,
  };
};

export default useAgencyTeam;
